import { validateAnyContentReference } from '@gitbook/app-content-refs';
import { type Inline, NODE_DATA_INVALID, Schema } from '@gitbook/slate';

import { INLINE_LINK, LEAF_RICH_BLOCKS } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_LINK]: {
            parent: {
                types: LEAF_RICH_BLOCKS,
            },
            data: {
                ref: validateAnyContentReference,
            },
            normalize: (change, violation, context) => {
                switch (violation) {
                    case NODE_DATA_INVALID: {
                        const link = context.node as Inline;

                        if (link.isEmpty) {
                            return change.removeNodeByKey(link.key);
                        }
                        return change.unwrapInlineByKey(link.key);
                    }
                }
            },
        },
    },
});
